/**
 * Exports for the UI package AND ONLY FOR
 * the UI package. Only export what we need
 * for the UI client. No reason to bundle
 * all of the server-side code into the
 * web app.
 *
 * As always BE CAREFUL with barrel files!
 */

export * from '../shared/constants.js';

export * from './plugin/users-ui-plugin.js';

// views
// export { default as Register } from './views/register.vue';
